module.exports = __webpack_public_path__ + "static/studio-2-76e2987ed95634136dd22d4d9e1009a7.jpg";